"use client";

import { SplashScreen } from "@/components/minimal-components/loading-screen";

export default function Loading() {
  return <SplashScreen />;
}
